import routes from 'features/Payments/routes';

const root = `${routes.root}/transfers`;

const beneficiaries = `${root}/beneficiaries`;

const newBeneficiary = `${beneficiaries}/new`;

const newTransfer = `${root}/new`;

const bulkTransfers = `${root}/bulk`;

export default {
  beneficiaries,
  bulkTransfers,
  newBeneficiary,
  /**
   * @deprecated to navigate, use the type-safe `navigateToNewTransfer` helper instead
   */
  newTransfer,
  root,
} as const;
